var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUberLogosvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 44,
    viewBox: "0 0 96 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9378 20.1554V0.698364H0.240234V20.4001C0.240234 27.8035 5.42586 32.6984 12.1367 32.6984C15.4311 32.6984 18.2984 31.4135 20.4337 29.2108V32.1477H25.0702V0.698364H20.3727V20.1554C20.3727 25.1726 17.0173 28.5378 12.6857 28.5378C8.29321 28.4766 4.9378 25.2338 4.9378 20.1554ZM29.7068 32.2089H34.1603V29.3332C36.2346 31.4747 39.163 32.7596 42.3353 32.7596C49.0462 32.7596 54.3538 27.4364 54.3538 20.7672C54.3538 14.098 49.0462 8.77485 42.3353 8.77485C39.163 8.77485 36.2956 10.0597 34.2214 12.2012V0.698364H29.7068V32.2089ZM34.1603 20.7672C34.1603 16.3007 37.6988 12.8131 42.0303 12.8131C46.3618 12.8131 49.9003 16.3007 49.9003 20.7672C49.9003 25.1726 46.3618 28.7213 42.0303 28.7213C37.6378 28.7213 34.1603 25.1726 34.1603 20.7672ZM57.0381 20.706C57.0381 27.5588 62.3458 32.6984 69.1786 32.6984C73.3271 32.6984 76.7435 30.8628 79.0618 27.8035L75.7674 25.3561C74.0592 27.62 71.8019 28.7213 69.1786 28.7213C65.3351 28.7213 62.2238 25.9068 61.6137 22.1745H80.2209V20.706C80.2209 13.8532 75.4014 8.77485 68.8126 8.77485C62.1017 8.77485 57.0381 14.2204 57.0381 20.706ZM68.6905 12.7519C72.0459 12.7519 74.8523 15.077 75.6454 18.6257H61.6747C62.5288 15.077 65.3351 12.7519 68.6905 12.7519ZM95.2898 13.3026V9.08078H93.7036C91.2023 9.08078 89.372 10.2433 88.2129 12.0789V9.26433H83.8204V32.2089H88.3349V19.1152C88.3349 15.5664 90.4702 13.2414 93.4595 13.2414H95.2898V13.3026Z",
    fill: "#778092"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.0495,
    height: 32,
    fill: "white",
    transform: "translate(0.240234 0.698364)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUberLogosvg);
export default __webpack_public_path__ + "static/media/uber_logo.svg.199ffc07b83bacfaae4ed3d6b2ac371f.svg";
export { ForwardRef as ReactComponent };